import { useCallback, useEffect, useState } from "react";
import { initPointerTracking } from "./lib/pointer";
import { Preloader } from "./components/ui/Preloader";
import { Cursor } from "./components/ui/Cursor";
import { Navbar } from "./components/ui/Navbar";
import { ScrollToTop } from "./components/ui/ScrollToTop";
import { Hero } from "./components/sections/Hero";
import { About } from "./components/sections/About";
import { Skills } from "./components/sections/Skills";
import { Projects } from "./components/sections/Projects";
import { Experience } from "./components/sections/Experience";
import { Contact } from "./components/sections/Contact";

export function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    initPointerTracking();
  }, []);

  const handleDone = useCallback(() => setLoaded(true), []);

  return (
    <div className="grain relative">
      <Cursor />
      <Preloader onDone={handleDone} />
      <Navbar />

      <main>
        <Hero start={loaded} />
        <About />
        <Skills />
        <Projects />
        <Experience />
        <Contact />
      </main>

      <ScrollToTop />
    </div>
  );
}
